<template>
  <div class="create-list-button">
    <v-menu v-if="hgEligibleReports.length > 0" offset-y class="new-list-menu">
      <v-btn
        slot="activator"
        :class="hgButtonStyle"
        flat
        depressed
        dark>
        Create List
        <v-icon>arrow_drop_down</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile v-for="(report, index) in hgEligibleReports" :key="index">
          <v-list-tile-title>
            <button class="test-crl-list" @click="getNewCrlName(report)">{{report.title}}</button>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    <hg-new-crl-dialog
      :hg-show-dialog="showNameDialog"
      :hg-report-id="selectedReportId"
      @cancel="cancel" />
  </div>
</template>

<script>
import NewCrlDialog from './NewCrlDialog.vue';

export default {
  data() {
    return {
      showNameDialog: false,
      selectedReportId: '',
      dialogKey: 0,
      domain: process.env.VUE_APP_HG_CLASSIC,
    };
  },
  props: {
    hgEligibleReports: {
      type: Array,
      required: true,
    },
    hgButtonStyle: {
      type: String,
      required: true,
    },
  },
  components: {
    'hg-new-crl-dialog': NewCrlDialog,
  },
  methods: {
    cancel() {
      this.showNameDialog = false;
      this.dialogKey += 1; // reinitialize dialog to clear veeValidate in dialog compontent
    },
    getNewCrlName(report) {
      if (report.crlCount === 0) {
        window.location = report.createCrlLink;
      } else {
        this.selectedReportId = report.id.toString();
        this.showNameDialog = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.create-list-button {
  display: inline-block;
}
</style>
